export enum BannerCriticality {
  INFO = 'INFO',
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL',
}

export enum CaseCreationBlock {
  NONE = 'NONE',
  RSU = 'RSU',
  PDI = 'PDI',
  ALL = 'ALL',
}

export interface DowntimeBanner {
  active: boolean;
  freeText: string;
  criticality: BannerCriticality;
  link?: string;
  caseCreationBlock: CaseCreationBlock;
}
